module.exports = __webpack_public_path__ + "static/img/bg0.a3cb3f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg0.png
// module id = lF2S
// module chunks = 78